$(document).ready(function() {
  var baseServerUrl = "https://blog.soapboxsoaps.com/soapCodeApp";
  var appCodeMethodUrl = "/com/rtslabs/controllers/processUserData.php";
  var serverUrl = baseServerUrl + "" + appCodeMethodUrl;

  addSoapBoxSearchElement();

  // GO button action
  $(".hope-code-form").on("submit", function(e) {
    e.preventDefault();
    var customerEnteredHopeCode = $(e.target).find(".soapCodeSearchBoxTxt").val();
    if (customerEnteredHopeCode && customerEnteredHopeCode != "") {
      $.ajax({
        type: "GET",
        url: serverUrl,
        data: {
          fname    : "fname",
          lname    : "",
          email    : "bypass@example.com",
          zip      : "00000",
          hopecode : customerEnteredHopeCode
        },
        dataType: "jsonp",
        jsonp: "callback",
        jsonpCallback: "jsonpcallback"
      });
    } else {
      //hopecode not entered
      alert("Please enter your hope code!");
    }
  });

  $("#hope_code_nav").click(function(e) {
    e.preventDefault();
    var el = $('#soapBoxUserInformationModal').detach();
    $('body').append("<div class='modal-backdrop fade in'>");
    $("body").append(el);
    $('#soapBoxUserInformationModal').modal({backdrop:false});

    $("body").on("click", ".modal-backdrop, .close", function() {
      $('.modal-backdrop').remove();
      $('#soapBoxUserInformationModal').modal('hide');
    });
  });
});

function jsonpcallback(json){
  console.log(json);
  if (json == 1) {
    alert("We're sorry this Hope Code does not exist. Please check your Hope Code again and re-enter.");
  } else {
    window.location.href = json;
  }
}

//create Hopecode search form
function addSoapBoxSearchElement(){
  var f = document.createElement("form");
  f.className = "form-group hope-code-form";
  f.id = "hope-code-form";

  //create input element
  var i = document.createElement("input");
  i.type = "text";
  i.name = "soapCodeSearchBoxTxt";
  i.id = "soapCodeSearchBoxTxt";
  i.className = "form-control text-input soapCodeSearchBoxTxt";
  i.placeholder = "ENTER HOPE CODE™";

  //create a checkbox
  var c = document.createElement("input");
  c.type = "submit";
  c.id = "soapCodeSearchBtn";
  c.name = "soapCodeSearchBtn";
  c.className = "btn btn-success";
  c.value = "Submit";

  // add all elements to the form
  f.appendChild(i);
  f.appendChild(c);

  // add the form inside the body
  $(".soapCodeBox").append(f);
  $(".soapCodeBoxModalDiv").append(getUserInfoModalWindow());
  $("#soapBoxUserInfoModalBody").append(getUserInfoFormFields());
}

// Getting user info form fields
function getUserInfoFormFields(){
  var tempUserForm = "<form name='userInfoForm' id='userInfoForm' class='form-group hopecodeform' onSubmit='return false'>";
  tempUserForm +=  "<div class='name-input'><input type='text' name='hopeCodeUserInfoFname' class='validate[required] form-control  text-input' onChange='formValidate()' placeholder='Name'/></div>";
  tempUserForm +=  "<div class='email-input'><input type='text' name='hopeCodeUserInfoEmail' class='validate[required,custom[email]] text-input form-control'  onChange='formValidate()' placeholder='Email'/></div>";
  tempUserForm +=  "<div class='zip-input'><input type='text' name='hopeCodeUserInfoZipCode' class='validate[required, text-input form-control'  onChange='formValidate()' placeholder='Postal Code'/></div>";
  tempUserForm += "";
  tempUserForm += "<div class='hope-input'><input type='text' name='hopeCodeUserInfoHopeCode' class='text-input form-control' placeholder='Hope Code'/></div>";
  tempUserForm += "<button type='button' id='processHopeCodeBtn' class='action_button'>Submit</button>";
  tempUserForm += "</form>";

  return tempUserForm;
}

// Adding modal window
function getUserInfoModalWindow(){
  var modal_image = "{{ settings.hope_modal_image | img_url: 'large' }}";
  var modalWindowVar = "<div id='soapBoxUserInformationModal' class='modal fade'><div class='modal-dialog'><button type='button' class='close' data-dismiss='modal' aria-label='Close'><span aria-hidden='true'>&times;</span></button><div class='modal-content'><div class='hope-code-left'><div class='modal-header'>";
  modalWindowVar += "<p class='modal-header-content'>";
  modalWindowVar += "<span class='submit-span'></span><span class='light'>{{ settings.hope_code_text }}</span><br>";
  modalWindowVar += "</p></div>";
  modalWindowVar +=  "<div class='modal-body' id='soapBoxUserInfoModalBody'></div></div>";
  modalWindowVar += "<div class='hope-code-right'></div>";
  modalWindowVar += "<div class='modal-footer1'></div></div></div></div>";

  return modalWindowVar; 
}

function formValidate(){
  $('#userInfoForm').validationEngine('hideAll');
}